import { GET_BILLING_PLANS } from "../contants";
import orderBy from "lodash/orderBy";

const initialState = {
  standardPlans: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BILLING_PLANS: {
      const { payload } = action;
      const orderedPlans = orderBy(
        payload,
        (plan) => plan?.prices[0]?.prices[0]?.value
      );
      return {
        ...state,
        standardPlans: orderedPlans,
      };
    }
    default:
      return state;
  }
};

export default reducer;
